export const boardMyTasksTour = {
  key: "boardMyTasks",
  version: 1,
  getSteps: (t) => [
    {
      target: '[data-tour="board-mytasks-header"]',
      content: t("Tour_BoardMyTasks_Header"),
      placement: "bottom",
      disableBeacon: true,
    },
    {
      target: '[data-tour="board-mytasks-buckets"]',
      content: t("Tour_BoardMyTasks_Buckets"),
      placement: "top",
    },
    {
      target: '[data-tour="board-mytasks-refresh"]',
      content: t("Tour_BoardMyTasks_Refresh"),
      placement: "left",
    },
  ],
};
